import { createUseStyles } from "react-jss";
import { breakpoints } from '../../../constants/breakpoints';

const styles = createUseStyles(() => ({
  modal: {
    width: '80vw',
    maxWidth: '80vw',
    '& .modal-body': {
      padding: 0,
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      width: "auto",
      maxWidth: "none",
    },
  },
  iframeContainer: {
    position: 'relative',
  },
  iframe: {
    width: '100%',
    height: '80vh',
    border: 'none',
    borderRadius: '8px',
  },
  spinnerOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

export default styles;